import { JFSRequest, executeRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { EmType } from '../screens/EntityManagement'
import { MessageTypes } from '../utils'
import { getDocumentCategoryName } from './../data/store/Root'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any, ignoreEmptyError: boolean) => {
  console.log('kycDocumentsListRq data:', data)
  let list = []

  if (data?.error?.message?.length > 0 && !ignoreEmptyError) {
    RootStore.message.setMessage(data?.error?.message, MessageTypes.ERROR)
  }
  data?.documentDetails?.map((doc) => {
    list.push({
      MERCHANT_DOCUMENT_TYPE: doc?.documentCategory,
      NAME: doc?.fileName,
      MERCHANT_DOCUMENT_NAME: getDocumentCategoryName(doc?.documentType, RootStore.documentCategories) ?? 'NA',
      RID: doc?.documentId,
      expiry: doc?.dateOfExpiry,
      DOCUMENTSTATUS: doc?.status,
      uploadId: doc?.uploadId,
      documentNumber: doc?.documentNumber,
    })
  })
  return list
}

const kycDocumentsListRq = (
  uploadId: string,
  tokens: any,
  type: string,
  aadharRejectedState: string,
  ignoreEmptyError: boolean,
) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.kycListByUploadId,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      uploadId: uploadId,
      uploadType: type === EmType.createSubGroup ? 'SUBGROUP' : type,
      ...(aadharRejectedState?.length > 0 && { status: aadharRejectedState }),
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data, ignoreEmptyError)
  })
}

export { kycDocumentsListRq }
